import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { Subscription } from "@/types"
import { fetchAllSubscriptions, fetchUserSubscriptions, fetchSubscriptionsSummary } from "./subscriptionsThunks"

interface SubscriptionsState {
  subscriptions: Subscription[]
  summary: any
  loading: boolean
  loaded: boolean
  error: string | null
}

const initialState: SubscriptionsState = {
  subscriptions: [],
  summary: null,
  loading: false,
  loaded: false,
  error: null,
}

const subscriptionsSlice = createSlice({
  name: "subscriptions",
  initialState,
  reducers: {
    mergeUserSubscriptions: (state, action: PayloadAction<Subscription[]>) => {
      const existingIds = new Set(state.subscriptions.map(s => s.id))
      const uniqueNew = action.payload.filter(s => !existingIds.has(s.id))
      state.subscriptions = [...state.subscriptions, ...uniqueNew]
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllSubscriptions.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchAllSubscriptions.fulfilled, (state, action: PayloadAction<Subscription[]>) => {
        state.loading = false
        state.loaded = true
        state.subscriptions = action.payload
      })
      .addCase(fetchAllSubscriptions.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload || "Failed to fetch subscriptions"
      })
      .addCase(fetchUserSubscriptions.fulfilled, (state, action: PayloadAction<Subscription[]>) => {
        const existingIds = new Set(state.subscriptions.map(s => s.id))
        const uniqueNew = action.payload.filter(s => !existingIds.has(s.id))
        state.subscriptions = [...state.subscriptions, ...uniqueNew]
      })
      .addCase(fetchSubscriptionsSummary.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchSubscriptionsSummary.fulfilled, (state, action) => {
        state.loading = false
        state.summary = action.payload
      })
      .addCase(fetchSubscriptionsSummary.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload || "Failed to fetch subscriptions summary"
      })
  },
})

export const { mergeUserSubscriptions } = subscriptionsSlice.actions
export default subscriptionsSlice.reducer
